import {
  FocusContext,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import React, { memo, useEffect, useMemo } from 'react'
import { filterListings } from './util/filterListings'
import { ListingPositionEnum } from './types'

import type { ChannelsProps } from './types'
import type { ChannelRow as TChannelRow } from './types'

const Channels = ({
  children,
  translateY,
  channels,
  baseTime,
  scheduleRange,
  timeOffsetMinutes,
  onLoad,
}: ChannelsProps) => {
  const { ref, focusKey } = useFocusable()

  const channelRows = useMemo<TChannelRow[]>(() => {
    if (channels.length > 0 && scheduleRange) {
      return [
        ...channels.map((channel) => {
          const filteredListings = filterListings(
            channel.listings,
            baseTime,
            scheduleRange.start,
            scheduleRange.end
          )

          let hiddenListingAtStart

          if (timeOffsetMinutes > 0) {
            hiddenListingAtStart =
              channel.listings[
                channel.listings.findIndex(
                  (l) =>
                    l.start_time === filteredListings[0]?.listing.start_time
                ) - 1
              ]
            hiddenListingAtStart =
              filteredListings[0]?.listing.duration / 60 > timeOffsetMinutes
                ? null
                : hiddenListingAtStart
            if (hiddenListingAtStart) {
              filteredListings.unshift({
                listing: hiddenListingAtStart,
                position: ListingPositionEnum.hiddenAtStart,
              })
            }
          }

          const hiddenListingAtEnd =
            channel.listings[
              channel.listings.findIndex(
                (l) =>
                  l.start_time ===
                  filteredListings[filteredListings.length - 1]?.listing
                    .start_time
              ) + 1
            ]

          if (hiddenListingAtEnd) {
            filteredListings.push({
              listing: hiddenListingAtEnd,
              position: ListingPositionEnum.hiddenAtEnd,
            })
          }

          return {
            channel,
            filteredListings,
            hiddenListingAtStart,
            hiddenListingAtEnd,
          }
        }),
      ]
    }
    return []
  }, [channels, scheduleRange])

  useEffect(() => {
    if (channelRows.length > 0 && ref.current) {
      setTimeout(onLoad)
    }
  }, [channelRows, ref])

  return (
    <FocusContext.Provider value={focusKey}>
      <div className="epg__channels">
        <div ref={ref} style={{ transform: `translateY(${translateY}px)` }}>
          {channelRows.map((channelRow, chIndex) =>
            children(channelRow, chIndex)
          )}
        </div>
      </div>
    </FocusContext.Provider>
  )
}

export default memo(Channels)
